import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <div className="text-2xl font-medium">Page not found</div>
      <Link to="/" className="text-primary underline">Go home</Link>
    </div>
  );
};

export default NotFound;